import amplitude from 'amplitude-js';

export const initAmplitude = (userId, callback) => {
  amplitude
    .getInstance()
    .init(process.env.REACT_APP_AMPLITUDE_KEY, userId || null, null, () =>
      callback('amplitude')
    );
};

export const setAmplitudeUserId = (userId) => {
  amplitude.getInstance().setUserId(userId);
};

export const sendAmplitudeData = (eventType, eventParams) => {
  const checkInit = setInterval(() => {
    if (window.sessionStorage.getItem('amplitudeInit') === 'true') {
      amplitude.getInstance().logEvent(eventType, eventParams);
      clearInterval(checkInit);
    }
  }, 500);
};

export const setAmplitudeUserProperties = (properties) => {
  const checkInit = setInterval(() => {
    if (window.sessionStorage.getItem('amplitudeInit') === 'true') {
      amplitude.getInstance().setUserProperties(properties);
      clearInterval(checkInit);
    }
  }, 500);
};
